<template>
  <svg id="Популярное" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <path id="Контур_1609" data-name="Контур 1609"
          d="M534.166-158.336c0,1.583-2.709,2.88-3,4.377-.305,1.542,1.7,3.774,1.107,5.193-.6,1.443-3.6,1.6-4.457,2.887s.128,4.124-.968,5.221-3.928.1-5.221.968-1.443,3.858-2.887,4.456c-1.419.588-3.651-1.413-5.193-1.107-1.5.3-2.793,3-4.377,3s-2.88-2.709-4.377-3c-1.542-.305-3.774,1.7-5.193,1.107-1.444-.6-1.6-3.6-2.887-4.457s-4.125.128-5.221-.968-.1-3.928-.968-5.221-3.858-1.444-4.457-2.887c-.588-1.418,1.413-3.651,1.108-5.193-.3-1.5-3.005-2.794-3.005-4.377s2.709-2.881,3.005-4.377c.305-1.542-1.7-3.774-1.107-5.193.6-1.443,3.6-1.6,4.457-2.887s-.128-4.125.968-5.221,3.928-.1,5.221-.968,1.443-3.858,2.887-4.457c1.419-.588,3.651,1.413,5.193,1.108,1.5-.3,2.793-3.005,4.377-3.005s2.881,2.709,4.377,3.005c1.542.3,3.774-1.7,5.193-1.108,1.443.6,1.6,3.6,2.887,4.457s4.124-.128,5.221.969.1,3.928.968,5.22,3.858,1.444,4.456,2.887c.588,1.419-1.413,3.651-1.107,5.193C531.457-161.216,534.166-159.919,534.166-158.336Z"
          transform="translate(-484.166 183.336)" fill="#ff005f"
    />
    <text id="хит" transform="translate(24.55 28.933)" fill="#fff" font-size="13" font-family="Roboto Slab"
          font-weight="700"
    >
      <tspan x="-11.0" y="0">хит</tspan>
    </text>
  </svg>
</template>

<script>
  export default {
    name: 'IconHit',
  }
</script>
